const creditCardRoutePrefix = '/kredittkort';

// INTRODUCTION_PAGE ('/'), INIT_APPLICATION_PAGE ('/init'),
// VOLUNTARY_BLOCK_STATUS_PAGE ('/kredittsperre'),
// PAYMENT_REMARK_STATUS_PAGE ('/betalingsanmerkning'),
// AGE_REJECTION_STATUS_PAGE ('/aldersgrense') and
// NOT_APPROVED_STATUS_PAGE ('/kan-ikke-tilby-kredittkort') run before
// a concrete application exists for the client, so they carry no uid: the
// credit-check block, payment remark and rejections are all detected at init
// time before the client holds a uid, while NOT_BANK_CUSTOMER_STATUS_PAGE is
// retained for legacy direct access (not reached from init). Every other page
// operates on a concrete application and takes the uid as a path param (mirrors
// new-loan).
const creditCardRouteObject = [
  { name: 'INTRODUCTION_PAGE', path: '/' },
  { name: 'INIT_APPLICATION_PAGE', path: '/init' },
  { name: 'YOUR_INFORMATION_PAGE', path: '/om-deg/:uid' },
  { name: 'CREDIT_LIMIT_PAGE', path: '/kredittgrense/:uid' },
  { name: 'PAYMENT_REMARK_STATUS_PAGE', path: '/betalingsanmerkning' },
  { name: 'NOT_BANK_CUSTOMER_STATUS_PAGE', path: '/ikke-bankkunde' },
  { name: 'CONSENT_PAGE', path: '/sbl-samtykke/:uid' },
  { name: 'CONSENT_DENIED_PAGE', path: '/ingen-sbl-samtykke/:uid' },
  { name: 'INCOME_PAGE', path: '/inntekt/:uid' },
  { name: 'HOUSING_STATUS_PAGE', path: '/boforhold/:uid' },
  { name: 'DEBT_PAGE', path: '/gjeld/:uid' },
  { name: 'OTHER_DEBT_PAGE', path: '/andre-gjeld/:uid' },
  { name: 'CAR_PAGE', path: '/bil/:uid' },
  { name: 'VACATION_HOME_PAGE', path: '/fritidsbolig/:uid' },
  { name: 'MARITAL_STATUS_PAGE', path: '/sivilstatus/:uid' },
  { name: 'CHILDREN_PAGE', path: '/barn/:uid' },
  { name: 'SUMMARY_PAGE', path: '/oppsummering/:uid' },
  { name: 'POLLING_PAGE', path: '/behandler/:uid' },
  { name: 'SUCCESS_STATUS_PAGE', path: '/innvilget/:uid' },
  { name: 'NOT_SIGNED_STATUS_PAGE', path: '/signering-avvist/:uid' },
  { name: 'MANUAL_STATUS_PAGE', path: '/manuell-behandling/:uid' },
  { name: 'REJECTED_STATUS_PAGE', path: '/avslag/:uid' },
  { name: 'RECEIVED_STATUS_PAGE', path: '/mottatt/:uid' },
  { name: 'VOLUNTARY_BLOCK_STATUS_PAGE', path: '/kredittsperre' },
  { name: 'AGE_REJECTION_STATUS_PAGE', path: '/aldersgrense' },
  {
    name: 'NOT_APPROVED_STATUS_PAGE',
    path: '/kan-ikke-tilby-kredittkort',
  },
  { name: 'COMPLETE_PAGE', path: '/fullfort/:uid' },
] as const;

export type CreditCardPage = (typeof creditCardRouteObject)[number]['name'];

export const creditCardPageToRoute: Record<CreditCardPage, string> =
  Object.fromEntries(
    creditCardRouteObject.map(({ name, path }) => [
      name,
      creditCardRoutePrefix + path,
    ]),
  ) as Record<CreditCardPage, string>;
